import { useState, useEffect, useContext } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as OrgSvg } from "assets/svg/organizations-not-active.svg";
import { ReactComponent as SettingsSvg } from "assets/svg/settings.svg";
import { AppContext } from "context/appContext";
import LocalStorageService from "service/localStorageService";
import styled from "@emotion/styled";
import styledConst from "styles";
import { APP_CONFIG } from "config/appConfig";

const SettingsIcon = styled(SettingsSvg)`
    path {
        fill: ${styledConst.Primary_White};
    }
`;

const SideNav = (props: any) => {
    const { storeData } = useContext(AppContext);
    const location = useLocation();

    const { organization } = storeData;
    const { currentOrgId, currentOrgInfo } = organization;

    const pathMappingDict: any = {
        dashboard: "1",
        gateways: "2",
        "gateways-all": "2",
        "gateways-group": "2",
        "gateway-details": "2",
        "gate-group-details": "2",
        networks: "3",
        "network-details": "3",
        "networks-add": "3",
        organization: "4",
        settings: "5",
        about: "6",
        events: "8",
        "event-details": "8",
    };

    const [activeKey, setActiveKey] = useState(
        pathMappingDict[location.pathname.split("/")[1]]
    );
    const [gatewaySubmenu, setGatewaySubmenu] = useState(false);
    const orgId = currentOrgId || LocalStorageService.getItem("orgId");

    const handleGateSubmenu = () => {
        setGatewaySubmenu(!gatewaySubmenu);
    };

    const handleChange = (key: any) => {
        setActiveKey(key);
    };

    const navArr = [
        {
            name: "Dashboards",
            resource: "dashboards",
            eventKey: "1",
            getURL: () => "/dashboard",
            renderIcon: () => (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.6757 4.1014C18.3976 3.79741 17.9253 3.77599 17.6204 4.05462L12.5594 8.68454L9.32765 5.88372C9.04682 5.64049 8.63006 5.64049 8.34946 5.88372L2.7727 10.7136C2.46074 10.9835 2.4269 11.4553 2.69699 11.767C2.84465 11.9375 3.05278 12.0252 3.26189 12.0252C3.4349 12.0252 3.60918 11.9649 3.75037 11.8427L8.83818 7.43631L12.0837 10.2489C12.3697 10.4968 12.7967 10.4916 13.077 10.2354L18.6289 5.15655C18.9329 4.87816 18.954 4.4059 18.6757 4.1014Z"
                        fill="white"
                    />
                    <path
                        d="M21.2687 1.63959C21.0936 1.46381 20.8439 1.38641 20.6005 1.43193L16.3681 2.22862C16.0958 2.28013 15.8742 2.47757 15.7925 2.74223C15.7109 3.00688 15.7821 3.29493 15.978 3.49087L19.3888 6.90163C19.531 7.04352 19.7217 7.1202 19.9168 7.1202C19.9898 7.1202 20.0632 7.10952 20.1352 7.08758C20.3991 7.00714 20.597 6.78735 20.6501 6.51646L21.4716 2.30901C21.5191 2.06605 21.4429 1.81537 21.2687 1.63959ZM19.4525 4.85296L18.0344 3.43485L19.7941 3.10372L19.4525 4.85296Z"
                        fill="white"
                    />
                    <path
                        d="M22.3153 21.0872H1.68466C1.3065 21.0872 1 21.4215 1 21.834C1 22.2466 1.3065 22.5809 1.68466 22.5809H22.3153C22.6937 22.5809 23 22.2466 23 21.834C23 21.4215 22.6935 21.0872 22.3153 21.0872Z"
                        fill="white"
                    />
                    <path
                        d="M11.9998 15.7842C11.5873 15.7842 11.2529 16.1185 11.2529 16.5311V21.834C11.2529 22.2466 11.5873 22.5809 11.9998 22.5809C12.4124 22.5809 12.7468 22.2466 12.7468 21.834V16.5311C12.7468 16.1185 12.4124 15.7842 11.9998 15.7842Z"
                        fill="white"
                    />
                    <path
                        d="M9.01253 11.3029C8.59998 11.3029 8.26562 11.6372 8.26562 12.0498V21.834C8.26562 22.2465 8.59998 22.5809 9.01253 22.5809C9.42508 22.5809 9.75944 22.2465 9.75944 21.834V12.0498C9.75939 11.6372 9.42503 11.3029 9.01253 11.3029Z"
                        fill="white"
                    />
                    <path
                        d="M14.9876 13.7924C14.5751 13.7924 14.2407 14.1268 14.2407 14.5394V21.8339C14.2407 22.2465 14.5751 22.5809 14.9876 22.5809C15.4002 22.5809 15.7345 22.2465 15.7345 21.8339V14.5394C15.7345 14.1268 15.4002 13.7924 14.9876 13.7924Z"
                        fill="white"
                    />
                    <path
                        d="M17.9754 8.56415C17.5629 8.56415 17.2285 8.89851 17.2285 9.31105V21.8338C17.2285 22.2464 17.5629 22.5808 17.9754 22.5808C18.388 22.5808 18.7223 22.2464 18.7223 21.8338V9.31105C18.7223 8.89851 18.388 8.56415 17.9754 8.56415Z"
                        fill="white"
                    />
                    <path
                        d="M20.9627 11.3029C20.5502 11.3029 20.2158 11.6372 20.2158 12.0498V21.834C20.2158 22.2465 20.5502 22.5809 20.9627 22.5809C21.3753 22.5809 21.7096 22.2465 21.7096 21.834V12.0498C21.7096 11.6372 21.3753 11.3029 20.9627 11.3029Z"
                        fill="white"
                    />
                    <path
                        d="M6.02474 17.7759C5.61219 17.7759 5.27783 18.1103 5.27783 18.5228V21.834C5.27783 22.2465 5.61219 22.5809 6.02474 22.5809C6.43729 22.5809 6.77164 22.2465 6.77164 21.834V18.5228C6.77164 18.1103 6.43729 17.7759 6.02474 17.7759Z"
                        fill="white"
                    />
                    <path
                        d="M3.03743 15.5352C2.62489 15.5352 2.29053 15.8696 2.29053 16.2822V21.834C2.29053 22.2466 2.62489 22.5809 3.03743 22.5809C3.44998 22.5809 3.78434 22.2466 3.78434 21.834V16.2822C3.78429 15.8696 3.44993 15.5352 3.03743 15.5352Z"
                        fill="white"
                    />
                </svg>
            ),
        },
        {
            name: "Gateways",
            resource: "gateways",
            eventKey: "2",
            getURL: () => "/gateways-all",
            renderIcon: () => (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.0711 2.92892C15.1823 1.04019 12.6711 0 10 0C7.32895 0 4.81766 1.04019 2.92892 2.92892C1.04019 4.81766 0 7.32895 0 10C0 12.6711 1.04019 15.1823 2.92892 17.0711C4.81766 18.9598 7.32895 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32895 18.9598 4.81766 17.0711 2.92892ZM15.5539 11.9687C15.5539 12.2536 15.3221 12.4852 15.0372 12.4852C14.7525 12.4852 14.5207 12.2536 14.5207 11.9687C14.5207 11.6838 14.7525 11.4522 15.0372 11.4522C15.3221 11.4522 15.5539 11.6838 15.5539 11.9687ZM4.44611 8.03131C4.44611 7.74643 4.67789 7.5148 4.96277 7.5148C5.2475 7.5148 5.47928 7.74643 5.47928 8.03131C5.47928 8.31619 5.2475 8.54782 4.96277 8.54782C4.67789 8.54782 4.44611 8.31604 4.44611 8.03131ZM16.7572 15.6744V14.4847C16.7572 14.1611 16.4948 13.8988 16.1713 13.8988C15.8476 13.8988 15.5853 14.1611 15.5853 14.4847V16.8314C15.3575 17.018 15.1202 17.1931 14.8744 17.3566V15.266C14.8744 14.9425 14.6121 14.68 14.2885 14.68C13.965 14.68 13.7025 14.9425 13.7025 15.266V18.013C13.3015 18.199 12.8845 18.356 12.4538 18.4808V8.33817H13.965C14.167 9.04449 14.818 9.56314 15.5882 9.56314C16.5193 9.56314 17.2766 8.80585 17.2766 7.87476C17.2766 6.94382 16.5193 6.18637 15.5882 6.18637C14.9103 6.18637 14.3246 6.58829 14.0562 7.16629H11.8678C11.5442 7.16629 11.2819 7.42859 11.2819 7.75223V18.7347C10.8632 18.7959 10.4353 18.8281 10 18.8281C5.13214 18.8281 1.17188 14.8679 1.17188 10C1.17188 9.52972 1.20926 9.06784 1.28036 8.61725H3.37921C3.61801 9.26025 4.23767 9.7197 4.96262 9.7197C5.89371 9.7197 6.651 8.96225 6.651 8.03131C6.651 7.10037 5.89371 6.34293 4.96262 6.34293C4.23767 6.34293 3.61801 6.80237 3.37921 7.44537H1.54922C1.90002 6.28754 2.4826 5.22964 3.2428 4.32556V5.07568C3.2428 5.39917 3.5051 5.66162 3.82874 5.66162C4.15237 5.66162 4.41467 5.39917 4.41467 5.07568V3.16849C4.64249 2.98203 4.87976 2.80685 5.12543 2.64343V4.29428C5.12543 4.61792 5.38788 4.88022 5.71136 4.88022C6.035 4.88022 6.2973 4.61792 6.2973 4.29428V1.987C6.65619 1.82053 7.02774 1.67725 7.41043 1.5596V11.8396H5.99503C5.75638 11.1966 5.13672 10.7372 4.41162 10.7372C3.48068 10.7372 2.72324 11.4946 2.72324 12.4255C2.72324 13.3566 3.48068 14.1139 4.41162 14.1139C5.13672 14.1139 5.75638 13.6545 5.99503 13.0115H7.99637C8.32001 13.0115 8.58231 12.7492 8.58231 12.4255V1.28632C9.04404 1.2114 9.51752 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13214 18.8281 10C18.8281 10.4703 18.7907 10.9322 18.7196 11.3828H16.6208C16.382 10.7397 15.7623 10.2803 15.0374 10.2803C14.1063 10.2803 13.349 11.0378 13.349 11.9687C13.349 12.8996 14.1063 13.6571 15.0374 13.6571C15.7623 13.6571 16.382 13.1976 16.6208 12.5546H18.4508C18.1 13.7125 17.5174 14.7705 16.7572 15.6744ZM15.5882 7.35825C15.8731 7.35825 16.1049 7.59003 16.1049 7.87476C16.1049 8.15964 15.8731 8.39127 15.5882 8.39127C15.3035 8.39127 15.0717 8.15964 15.0717 7.87476C15.0717 7.59003 15.3035 7.35825 15.5882 7.35825ZM4.92828 12.4255C4.92828 12.7104 4.6965 12.942 4.41177 12.942C4.12689 12.942 3.89511 12.7104 3.89511 12.4255C3.89511 12.1408 4.12689 11.909 4.41177 11.909C4.6965 11.909 4.92828 12.1408 4.92828 12.4255Z"
                        fill="white"
                    />
                    <path
                        d="M13.0233 2.0314C12.0922 2.0314 11.3347 2.7887 11.3347 3.71979C11.3347 3.918 11.3694 4.10812 11.4324 4.28497L9.55661 5.85159C9.4234 5.96283 9.34634 6.12762 9.34634 6.30127V13.7372L8.54221 14.1716C8.24466 13.9099 7.8551 13.7508 7.42862 13.7508C6.49768 13.7508 5.74023 14.5081 5.74023 15.4391C5.74023 16.3701 6.49768 17.1275 7.42862 17.1275C8.35971 17.1275 9.117 16.3701 9.117 15.4391C9.117 15.3586 9.11105 15.2795 9.10007 15.2022L10.2108 14.6021C10.4003 14.4998 10.5182 14.3018 10.5182 14.0866V6.57532L12.1842 5.18402C12.4315 5.32623 12.7179 5.40817 13.0233 5.40817C13.9542 5.40817 14.7116 4.65073 14.7116 3.71979C14.7115 2.7887 13.9542 2.0314 13.0233 2.0314ZM6.91211 15.4391C6.91211 15.1543 7.14389 14.9226 7.42862 14.9226C7.7135 14.9226 7.94513 15.1543 7.94513 15.4391C7.94513 15.7239 7.7135 15.9557 7.42862 15.9557C7.14389 15.9557 6.91211 15.7239 6.91211 15.4391ZM12.5066 3.71979C12.5066 3.43491 12.7384 3.20328 13.0233 3.20328C13.308 3.20328 13.5398 3.43491 13.5398 3.71979C13.5398 4.00452 13.308 4.2363 13.0233 4.2363C12.7384 4.2363 12.5066 4.00452 12.5066 3.71979Z"
                        fill="white"
                    />

                    <defs>
                        <clipPath id="clip0">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            onClick: handleGateSubmenu,
            renderChildren: () => (
                <ul className={gatewaySubmenu ? "submenu show" : "submenu"}>
                    <li>
                        <Link
                            className="submenu-item"
                            to="/gateways-all"
                            onClick={props.updateSideMenu}
                        >
                            All Gateways
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="submenu-item"
                            to="/gateways-group"
                            onClick={props.updateSideMenu}
                        >
                            Gateway Groups
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="submenu-item"
                            to="/gateways"
                            onClick={props.updateSideMenu}
                        >
                            Standalone Gateways
                        </Link>
                    </li>
                </ul>
            ),
        },
        {
            name: "Networks",
            resource: "networks",
            eventKey: "3",
            getURL: () => "/networks",
            renderIcon: () => (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_5382_81)">
                        <path
                            d="M14.25 19.5C14.25 19.8978 14.408 20.2794 14.6893 20.5607C14.9706 20.842 15.3522 21 15.75 21C16.1478 21 16.5294 20.842 16.8107 20.5607C17.092 20.2794 17.25 19.8978 17.25 19.5C17.25 19.1022 17.092 18.7206 16.8107 18.4393C16.5294 18.158 16.1478 18 15.75 18C15.3522 18 14.9706 18.158 14.6893 18.4393C14.408 18.7206 14.25 19.1022 14.25 19.5Z"
                            fill="white"
                        />
                        <path
                            d="M14.25 4.5C14.25 4.89782 14.408 5.27936 14.6893 5.56066C14.9706 5.84196 15.3522 6 15.75 6C16.1478 6 16.5294 5.84196 16.8107 5.56066C17.092 5.27936 17.25 4.89782 17.25 4.5C17.25 4.10218 17.092 3.72064 16.8107 3.43934C16.5294 3.15804 16.1478 3 15.75 3C15.3522 3 14.9706 3.15804 14.6893 3.43934C14.408 3.72064 14.25 4.10218 14.25 4.5Z"
                            fill="white"
                        />
                        <path
                            d="M1.5 12C1.5 12.3978 1.65804 12.7794 1.93934 13.0607C2.22064 13.342 2.60218 13.5 3 13.5C3.39782 13.5 3.77936 13.342 4.06066 13.0607C4.34196 12.7794 4.5 12.3978 4.5 12C4.5 11.6022 4.34196 11.2206 4.06066 10.9393C3.77936 10.658 3.39782 10.5 3 10.5C2.60218 10.5 2.22064 10.658 1.93934 10.9393C1.65804 11.2206 1.5 11.6022 1.5 12Z"
                            fill="white"
                        />
                        <path
                            d="M21 9C20.3367 9.00202 19.6929 9.22399 19.1693 9.63116C18.6457 10.0383 18.2719 10.6077 18.1066 11.25H14.8934C14.7872 10.827 14.5893 10.4325 14.3137 10.0945C14.0381 9.75653 13.6915 9.48329 13.2985 9.29417C12.9055 9.10505 12.4757 9.00467 12.0396 9.00016C11.6035 8.99565 11.1717 9.0871 10.7749 9.26805L8.3925 6.2904C8.7845 5.77564 8.99779 5.14702 9 4.5C9 3.90666 8.82405 3.32664 8.49441 2.83329C8.16477 2.33994 7.69623 1.95543 7.14805 1.72836C6.59987 1.5013 5.99667 1.44189 5.41473 1.55765C4.83279 1.6734 4.29824 1.95912 3.87868 2.37868C3.45912 2.79824 3.1734 3.33279 3.05765 3.91473C2.94189 4.49667 3.0013 5.09987 3.22836 5.64805C3.45543 6.19623 3.83994 6.66477 4.33329 6.99441C4.82664 7.32405 5.40666 7.5 6 7.5C6.42288 7.4989 6.84064 7.40752 7.22535 7.23195L9.60735 10.2095C9.21352 10.7232 9.00008 11.3525 9.00008 11.9999C9.00008 12.6472 9.21352 13.2765 9.60735 13.7902L7.2255 16.7678C6.84072 16.5923 6.42291 16.501 6 16.5C5.40666 16.5 4.82664 16.6759 4.33329 17.0056C3.83994 17.3352 3.45543 17.8038 3.22836 18.3519C3.0013 18.9001 2.94189 19.5033 3.05765 20.0853C3.1734 20.6672 3.45912 21.2018 3.87868 21.6213C4.29824 22.0409 4.83279 22.3266 5.41473 22.4424C5.99667 22.5581 6.59987 22.4987 7.14805 22.2716C7.69623 22.0446 8.16477 21.6601 8.49441 21.1667C8.82405 20.6734 9 20.0933 9 19.5C8.9978 18.853 8.78451 18.2244 8.3925 17.7096L10.7744 14.7321C11.1712 14.9131 11.603 15.0046 12.0392 15.0001C12.4754 14.9956 12.9052 14.8952 13.2983 14.7061C13.6913 14.517 14.038 14.2437 14.3136 13.9056C14.5893 13.5676 14.7872 13.1731 14.8934 12.75H18.1066C18.2478 13.292 18.5381 13.7836 18.9446 14.1689C19.3512 14.5542 19.8576 14.8178 20.4064 14.9297C20.9553 15.0416 21.5245 14.9974 22.0494 14.8021C22.5744 14.6067 23.034 14.2681 23.3762 13.8247C23.7183 13.3812 23.9293 12.8507 23.9851 12.2934C24.0409 11.736 23.9392 11.1742 23.6918 10.6718C23.4443 10.1693 23.0609 9.74626 22.5851 9.45075C22.1093 9.15524 21.5601 8.99908 21 9ZM4.5 4.5C4.5 4.20333 4.58797 3.91332 4.7528 3.66665C4.91762 3.41997 5.15189 3.22771 5.42598 3.11418C5.70007 3.00065 6.00167 2.97095 6.29264 3.02882C6.58361 3.0867 6.85088 3.22956 7.06066 3.43934C7.27044 3.64912 7.4133 3.91639 7.47118 4.20737C7.52906 4.49834 7.49935 4.79994 7.38582 5.07403C7.27229 5.34812 7.08003 5.58238 6.83336 5.74721C6.58668 5.91203 6.29667 6 6 6C5.60232 5.99954 5.22105 5.84136 4.93985 5.56016C4.65864 5.27895 4.50046 4.89769 4.5 4.5ZM6 21C5.70333 21 5.41332 20.912 5.16665 20.7472C4.91997 20.5824 4.72771 20.3481 4.61418 20.074C4.50065 19.7999 4.47095 19.4983 4.52882 19.2074C4.5867 18.9164 4.72956 18.6491 4.93934 18.4393C5.14912 18.2296 5.41639 18.0867 5.70737 18.0288C5.99834 17.9709 6.29994 18.0006 6.57403 18.1142C6.84812 18.2277 7.08238 18.42 7.24721 18.6666C7.41203 18.9133 7.5 19.2033 7.5 19.5C7.49955 19.8977 7.34136 20.2789 7.06016 20.5602C6.77895 20.8414 6.39769 20.9995 6 21ZM12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5007 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.4995 12.3977 13.3414 12.779 13.0602 13.0602C12.779 13.3414 12.3977 13.4995 12 13.5ZM21 13.5C20.7033 13.5 20.4133 13.412 20.1666 13.2472C19.92 13.0824 19.7277 12.8481 19.6142 12.574C19.5007 12.2999 19.4709 11.9983 19.5288 11.7074C19.5867 11.4164 19.7296 11.1491 19.9393 10.9393C20.1491 10.7296 20.4164 10.5867 20.7074 10.5288C20.9983 10.4709 21.2999 10.5006 21.574 10.6142C21.8481 10.7277 22.0824 10.92 22.2472 11.1666C22.412 11.4133 22.5 11.7033 22.5 12C22.4995 12.3977 22.3414 12.779 22.0602 13.0602C21.779 13.3414 21.3977 13.4995 21 13.5Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_5382_81">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            isShow: () => APP_CONFIG.APP_IS_ONPREM,
        },
        {
            name: "Events",
            resource: "event-info",
            eventKey: "8",
            getURL: () => "/events",
            renderIcon: () => (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M24 5.625V11.7188C24 12.2366 23.5803 12.6563 23.0625 12.6563C22.5447 12.6563 22.125 12.2366 22.125 11.7188V5.625C22.125 4.59119 21.2838 3.75 20.25 3.75H19.0313V4.6875C19.0313 5.20532 18.6116 5.625 18.0938 5.625C17.5759 5.625 17.1563 5.20532 17.1563 4.6875V3.75H12.8906V4.6875C12.8906 5.20532 12.4709 5.625 11.9531 5.625C11.4353 5.625 11.0156 5.20532 11.0156 4.6875V3.75H6.79688V4.6875C6.79688 5.20532 6.3772 5.625 5.85938 5.625C5.34155 5.625 4.92188 5.20532 4.92188 4.6875V3.75H3.75C2.71619 3.75 1.875 4.59119 1.875 5.625V20.25C1.875 21.2838 2.71619 22.125 3.75 22.125H7.78125C8.29907 22.125 8.71875 22.5447 8.71875 23.0625C8.71875 23.5803 8.29907 24 7.78125 24H3.75C1.68219 24 0 22.3178 0 20.25V5.625C0 3.55719 1.68219 1.875 3.75 1.875H4.92188V0.9375C4.92188 0.419678 5.34155 0 5.85938 0C6.3772 0 6.79688 0.419678 6.79688 0.9375V1.875H11.0156V0.9375C11.0156 0.419678 11.4353 0 11.9531 0C12.4709 0 12.8906 0.419678 12.8906 0.9375V1.875H17.1563V0.9375C17.1563 0.419678 17.5759 0 18.0938 0C18.6116 0 19.0313 0.419678 19.0313 0.9375V1.875H20.25C22.3178 1.875 24 3.55719 24 5.625ZM6.79688 9.84375C6.79688 9.32593 6.3772 8.90625 5.85938 8.90625C5.34155 8.90625 4.92188 9.32593 4.92188 9.84375C4.92188 10.3616 5.34155 10.7813 5.85938 10.7813C6.3772 10.7813 6.79688 10.3616 6.79688 9.84375ZM6.79688 13.9219C6.79688 13.4041 6.3772 12.9844 5.85938 12.9844C5.34155 12.9844 4.92188 13.4041 4.92188 13.9219C4.92188 14.4397 5.34155 14.8594 5.85938 14.8594C6.3772 14.8594 6.79688 14.4397 6.79688 13.9219ZM5.85938 17.0625C5.34155 17.0625 4.92188 17.4822 4.92188 18C4.92188 18.5178 5.34155 18.9375 5.85938 18.9375C6.3772 18.9375 6.79688 18.5178 6.79688 18C6.79688 17.4822 6.3772 17.0625 5.85938 17.0625ZM9.9375 10.7813C10.4553 10.7813 10.875 10.3616 10.875 9.84375C10.875 9.32593 10.4553 8.90625 9.9375 8.90625C9.41968 8.90625 9 9.32593 9 9.84375C9 10.3616 9.41968 10.7813 9.9375 10.7813Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.9998 17.4C23.9998 21.0451 21.0449 24 17.3998 24C13.7547 24 10.7998 21.0451 10.7998 17.4C10.7998 13.7549 13.7547 10.8 17.3998 10.8C21.0449 10.8 23.9998 13.7549 23.9998 17.4ZM16.7998 13.8C16.7998 13.4686 17.0684 13.2 17.3998 13.2C17.7312 13.2 17.9998 13.4686 17.9998 13.8V17.4C17.9998 17.7314 17.7312 18 17.3998 18H13.7998C13.4684 18 13.1998 17.7314 13.1998 17.4C13.1998 17.0686 13.4684 16.8 13.7998 16.8H16.7998V13.8Z"
                        fill="white"
                    />
                </svg>
            ),
            isShow: () => !APP_CONFIG.APP_IS_ONPREM,
        },
        {
            name: "Organisation",
            eventKey: "4",
            getURL: () => `/organisation/${orgId}`,
            renderIcon: () => <OrgSvg />,
            isShow: ({ isDefault }: any) => currentOrgId && !isDefault,
        },
        {
            name: "Reports",
            resource: "report-info",
            eventKey: "9",
            getURL: () => "/reports",
            renderIcon: () => (
                <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.5858 13.0312C18.3433 12.7281 17.9129 12.663 17.5936 12.8691L17.5311 12.9141L12.9999 16.5391L10.9686 14.9141C10.7136 14.71 10.3556 14.6948 10.0839 14.876L5.58386 17.876L5.52234 17.9219C5.22896 18.1636 5.16045 18.5929 5.37586 18.916C5.59121 19.239 6.01355 19.3407 6.34949 19.1631L6.41589 19.124L10.4598 16.4277L12.5311 18.0859C12.805 18.3051 13.1947 18.3051 13.4686 18.0859L18.4686 14.0859L18.5262 14.0352C18.7976 13.7689 18.8284 13.3345 18.5858 13.0312ZM6.74988 9C6.74988 8.53587 6.93439 8.09088 7.26257 7.7627C7.54976 7.47551 7.92638 7.29855 8.32703 7.25879L8.49988 7.25C8.96401 7.25 9.40899 7.43451 9.73718 7.7627C10.0654 8.09088 10.2499 8.53587 10.2499 9C10.2499 9.46413 10.0654 9.90912 9.73718 10.2373C9.40899 10.5655 8.96401 10.75 8.49988 10.75C8.03575 10.75 7.59076 10.5655 7.26257 10.2373C6.93439 9.90912 6.74988 9.46413 6.74988 9ZM13.9999 8.75C13.5857 8.75 13.2499 9.08579 13.2499 9.5C13.2499 9.91421 13.5857 10.25 13.9999 10.25H17.9999C18.4141 10.25 18.7499 9.91421 18.7499 9.5C18.7499 9.08579 18.4141 8.75 17.9999 8.75H13.9999ZM14.9999 5.75C14.5857 5.75 14.2499 6.08579 14.2499 6.5C14.2499 6.91421 14.5857 7.25 14.9999 7.25H17.9999C18.4141 7.25 18.7499 6.91421 18.7499 6.5C18.7499 6.08579 18.4141 5.75 17.9999 5.75H14.9999ZM5.24988 9C5.24988 9.86195 5.59253 10.6884 6.20203 11.2979C6.81152 11.9073 7.63793 12.25 8.49988 12.25C9.36183 12.25 10.1882 11.9073 10.7977 11.2979C11.4072 10.6884 11.7499 9.86195 11.7499 9C11.7499 8.13805 11.4072 7.31164 10.7977 6.70215C10.1882 6.09266 9.36183 5.75 8.49988 5.75C7.63793 5.75 6.81152 6.09266 6.20203 6.70215C5.59253 7.31164 5.24988 8.13805 5.24988 9Z"
                        fill="white"
                    />
                    <path
                        d="M20.25 20.75H3.75V4.25H20.25V20.75ZM2.25 20.9004C2.2501 21.2583 2.39242 21.6014 2.64551 21.8545C2.89859 22.1076 3.24171 22.2499 3.59961 22.25H20.4004C20.7583 22.2499 21.1014 22.1076 21.3545 21.8545C21.6076 21.6014 21.7499 21.2583 21.75 20.9004V4.09961C21.7499 3.74171 21.6076 3.39859 21.3545 3.14551C21.1014 2.89243 20.7583 2.7501 20.4004 2.75H3.59961C3.24171 2.7501 2.89859 2.89243 2.64551 3.14551C2.39243 3.39859 2.2501 3.74171 2.25 4.09961V20.9004Z"
                        fill="white"
                    />
                </svg>
            ),
            isShow: () => APP_CONFIG.APP_IS_ONPREM,
        },
        {
            name: "Settings",
            eventKey: "5",
            getURL: () => `/settings`,
            renderIcon: () => <SettingsIcon />,
        },
        {
            name: "About",
            eventKey: "6",
            getURL: () => "/about",
            renderIcon: () => (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M19.3261 3.03442C17.3693 1.07763 14.7676 0 12.0004 0C9.23305 0 6.63135 1.07763 4.67456 3.03442C2.71777 4.99121 1.64014 7.59287 1.64014 10.3602C1.64014 13.1275 2.71782 15.7291 4.67456 17.6859C6.46477 19.4761 8.79481 20.5305 11.2975 20.697V24L12.4072 23.2122C12.6027 23.0734 17.2204 19.7876 19.4763 17.5318C20.3927 16.6154 21.1094 15.5265 21.6066 14.2953C22.1068 13.0565 22.3605 11.7325 22.3605 10.3602C22.3605 7.59287 21.2829 4.99121 19.3261 3.03442ZM12.7032 21.2592V19.3147H12.0004C7.06279 19.3147 3.04581 15.2977 3.04581 10.3602C3.04581 5.42266 7.06279 1.40567 12.0004 1.40567C16.9379 1.40567 20.9548 5.42266 20.9548 10.3602C20.9548 12.7495 20.0767 14.9435 18.4823 16.5379C16.9658 18.0544 14.2313 20.1321 12.7032 21.2592Z"
                        fill="white"
                    />
                    <path
                        d="M12 3.71179C8.33407 3.71179 5.35156 6.69425 5.35156 10.3602C5.35156 14.0262 8.33402 17.0086 12 17.0086C15.666 17.0086 18.6484 14.0262 18.6484 10.3602C18.6484 6.69425 15.666 3.71179 12 3.71179ZM12 15.603C9.10915 15.603 6.75723 13.2511 6.75723 10.3602C6.75723 7.46938 9.10911 5.11746 12 5.11746C14.8909 5.11746 17.2427 7.46934 17.2427 10.3602C17.2427 13.2511 14.8909 15.603 12 15.603Z"
                        fill="white"
                    />
                    <path
                        d="M11.292 9.31653H12.7082V13.3567H11.292V9.31653Z"
                        fill="white"
                    />
                    <path
                        d="M12 7.36353C11.4782 7.36353 11.1353 7.69151 11.1353 8.1164C11.1353 8.54128 11.4781 8.86927 12 8.86927C12.5218 8.86927 12.8646 8.54128 12.8646 8.09405C12.8646 7.66916 12.5218 7.36353 12 7.36353Z"
                        fill="white"
                    />

                    <defs>
                        <clipPath id="clip0">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
    ];

    useEffect(() => {
        const currentMenu = navArr.find(
            (item) => {
                const menuURL = item.getURL();
                return location.pathname === menuURL || 
                       location.pathname.startsWith(menuURL + "/") ||
                       (menuURL === "/networks" && location.pathname.startsWith("/network"));
            }
        );
        currentMenu?.eventKey &&
            String(currentMenu?.eventKey) !== String(activeKey) &&
            setActiveKey(currentMenu.eventKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const getMenu = () => {
        return (
            <nav className={props.sideMenu ? "sidebar show" : "sidebar"}>
                <div className="position-sticky">
                    <Nav
                        defaultActiveKey={activeKey}
                        as="ul"
                        className="flex-column"
                        onSelect={handleChange}
                    >
                        {navArr.map(
                            ({
                                renderIcon,
                                name,
                                eventKey,
                                getURL,
                                isShow = () => true,
                                onClick = props.updateSideMenu,
                                renderChildren = () => null,
                            }) =>
                                isShow(currentOrgInfo) ? (
                                    <Nav.Item as="li" key={name}>
                                        <Nav.Link
                                            eventKey={eventKey}
                                            as={Link}
                                            to={getURL()}
                                            className={`${
                                                activeKey === eventKey
                                                    ? "actived"
                                                    : ""
                                            }`}
                                            onClick={onClick}
                                        >
                                            {renderIcon()}
                                            <span>{name}</span>
                                        </Nav.Link>
                                        {renderChildren()}
                                    </Nav.Item>
                                ) : null
                        )}
                    </Nav>
                </div>
            </nav>
        );
    };

    return (
        <div className="parent">
            {getMenu()}
            {props.children}
        </div>
    );
};

export default SideNav;
